/**
 * Wishlist Animations - Luxury Micro-interactions
 * Inspired by premium effects library
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    updateWishlistCount();
    initStaggeredReveal();
    initRemoveAnimations();
    initImageHoverEffects();
    markWishlistWithItems();
    
    // Update count when items are added/removed
    window.addEventListener('storage', updateWishlistCount);
  }
  
  /**
   * Add visual indicator class when wishlist has items
   */
  function markWishlistWithItems() {
    const wishlistContainer = document.querySelector('.wishlist');
    const scrollHint = document.querySelector('.wishlist-hero__scroll-hint');
    const wishlistData = localStorage.getItem('shopify-wishlist');
    const count = wishlistData ? wishlistData.split(',').filter(item => item.trim()).length : 0;
    
    if (wishlistContainer && count > 0) {
      wishlistContainer.classList.add('has-items');
      
      // Show scroll hint
      if (scrollHint) {
        scrollHint.style.display = 'flex';
      }
    } else {
      // Hide scroll hint when no items
      if (scrollHint) {
        scrollHint.style.display = 'none';
      }
    }
  }

  /**
   * Update wishlist count in hero section
   */
  function updateWishlistCount() {
    const countElement = document.querySelector('.wishlist-count-number');
    if (!countElement) return;

    const wishlistData = localStorage.getItem('shopify-wishlist');
    const count = wishlistData ? wishlistData.split(',').filter(item => item.trim()).length : 0;
    
    console.log('[Wishlist Hero] Updating count from localStorage:', wishlistData, 'Count:', count);
    
    // Animate count change
    animateNumber(countElement, parseInt(countElement.textContent) || 0, count);
    
    // Update text (singular/plural)
    const textElement = document.querySelector('.wishlist-count-text');
    if (textElement) {
      textElement.textContent = count === 1 ? 'item awaiting you' : 'items awaiting you';
    }
    
    // Also update the badge in header to keep them in sync
    const badge = document.querySelector('.dtxc-wishlist-count span');
    if (badge) {
      badge.textContent = count;
      console.log('[Wishlist Hero] Synced badge count to:', count);
    }
  }

  /**
   * Animate number change with easing
   */
  function animateNumber(element, start, end) {
    const duration = 600;
    const startTime = performance.now();
    
    function update(currentTime) {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Ease out cubic
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(start + (end - start) * easeProgress);
      
      element.textContent = current;
      
      if (progress < 1) {
        requestAnimationFrame(update);
      }
    }
    
    requestAnimationFrame(update);
  }

  /**
   * Staggered reveal animation for wishlist items
   */
  function initStaggeredReveal() {
    const items = document.querySelectorAll('[data-wishlist-item]');
    
    // Use Intersection Observer for scroll-triggered animations
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, index * 100);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    });

    items.forEach(item => {
      item.style.opacity = '0';
      item.style.transform = 'translateY(20px)';
      item.style.transition = 'opacity 0.6s ease-out, transform 0.6s ease-out';
      observer.observe(item);
    });
  }

  /**
   * Smooth remove animations
   */
  function initRemoveAnimations() {
    const removeButtons = document.querySelectorAll('[data-remove-wishlist]');
    
    removeButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        const item = this.closest('[data-wishlist-item]');
        if (!item) return;

        // Prevent default removal
        e.preventDefault();
        
        // Animate out
        item.style.transform = 'scale(0.95)';
        item.style.opacity = '0';
        
        setTimeout(() => {
          // Find the actual remove link and trigger it
          const removeLink = this.querySelector('.remove-item');
          if (removeLink) {
            removeLink.click();
          }
        }, 300);
      });
    });
  }

  /**
   * Parallax-style image hover effect
   */
  function initImageHoverEffects() {
    const imageWrappers = document.querySelectorAll('.wishlist-item__image-wrapper');
    
    imageWrappers.forEach(wrapper => {
      const image = wrapper.querySelector('.wishlist-item__image');
      if (!image) return;

      wrapper.addEventListener('mousemove', function(e) {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left;
        const y = e.clientY - rect.top;
        
        const centerX = rect.width / 2;
        const centerY = rect.height / 2;
        
        const deltaX = (x - centerX) / centerX;
        const deltaY = (y - centerY) / centerY;
        
        // Subtle parallax movement
        image.style.transform = `scale(1.05) translate(${deltaX * 5}px, ${deltaY * 5}px)`;
      });

      wrapper.addEventListener('mouseleave', function() {
        image.style.transform = 'scale(1.05)';
      });
    });
  }

  /**
   * Magnetic button effect (inspired by effects library)
   */
  function initMagneticButtons() {
    const buttons = document.querySelectorAll('.wishlist-item__button');
    
    buttons.forEach(button => {
      button.addEventListener('mousemove', function(e) {
        const rect = this.getBoundingClientRect();
        const x = e.clientX - rect.left - rect.width / 2;
        const y = e.clientY - rect.top - rect.height / 2;
        
        this.style.transform = `translate(${x * 0.1}px, ${y * 0.1}px)`;
      });

      button.addEventListener('mouseleave', function() {
        this.style.transform = 'translate(0, 0)';
      });
    });
  }

  // Initialize magnetic buttons after a short delay
  setTimeout(initMagneticButtons, 500);

})();
